export default "__VITE_ASSET__KMtwDs41__"